export enum UigProductExportTypes {
  CSV,
  ZIP
}

export enum UigExportColumns {
  ARTICLENUMBER,
  PICTURE,
  MANUFACTURER,
  PRODUCTNAME,
  CHANGES,
  CAMPAIGN,
  PRICE_PURCHASE,
  PRICE_SALE_UVP,
  PRICE_SALE,
  PACKAGEITEM,
  EAN1,
  SUPPLIERPRODUCTCODE,
  IMAGETEXTLONG,
  CAMPAIGNSASSIGNMENT,
  MVGR2,
  PRICE_RINGFOTO_UVP
}

